module.exports = __webpack_public_path__ + "static/media/notificaciones.89a5c6fd.svg";